export default __webpack_public_path__ + "static/illustration-3-e872dda7632c818d154826444e8b8d28.png";